module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_link_button_fukidashi-5c604fdb8fb845ed8b98e1c7fe0fd979.svg";